import DashboardLayout from '../Components/Layout/DashboardLayout';
import Chatbot from '../Features/Chatbot/chatbot';

const Chatboat = () => {
  return (
    <DashboardLayout>
      <Chatbot />
    </DashboardLayout>
  );
};

export default Chatboat;
